// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const WorkerDetails = () => {
//   const [workers, setWorkers] = useState([]);
//   const [selectedWorker, setSelectedWorker] = useState(null);
//   const [bills, setBills] = useState([]);
//   const [productStats, setProductStats] = useState({});
//   const [isShowingAll, setIsShowingAll] = useState(false);
//   const [requests, setRequests] = useState([]);

//   const fetchRequests = async () => {
// const res = await axios.get(
//   "http://localhost/murugan/cart-request/get_all.php"
// );
//     setRequests(res.data);
//   };

//   useEffect(() => {
//     fetchRequests();
//   }, []);

//   const handleApprove = async (id, cleanReqData) => {
//     try {
//       await axios.post(
//         `http://localhost/murugan/cart-request/approve.php?id=${id}`,
//         cleanReqData
//       );
//       fetchRequests();
//       fetchAllBills();
//     } catch (err) {
//       console.error("Approval failed", err.response?.data || err.message);
//     }
//   };

// const handleReject = async (id) => {
//   try {
//     await axios.post(
//       `http://localhost/murugan/cart-request/reject.php?id=${id}`
//     );
//     fetchRequests();
//   } catch (err) {
//     console.error("Rejection failed", err);
//   }
// };

// useEffect(() => {
//   const fetchWorkers = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       // const res = await axios.get("http://localhost:5002/api/workers", {
//       const res = await axios.get(
//         "http://localhost/murugan/worker/get_all.php",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       setWorkers(res.data); // res.data should be an array of worker objects
//     } catch (err) {
//       console.error("Failed to fetch workers:", err);
//     }
//   };

//   fetchWorkers();
// }, []);

//   const fetchBills = async (workerId) => {
//     try {
//       // const res = await axios.get(`http://localhost:5000/bill/${workerId}`);
// const res = await axios.get(
//   `http://localhost/murugan/bills/get_by_worker.php?worker_id=${workerId}`
// );
//       const usageBills = res.data.filter((bill) => bill.type !== "deduction"); // 👈 filter here
//       setBills(usageBills);
//       setSelectedWorker(workerId);
//       setIsShowingAll(false);
//       computeProductStats(usageBills);
//     } catch (err) {
//       console.error("Failed to fetch bills", err);
//     }
//   };

//   const fetchAllBills = async () => {
//     try {
//       // const res = await axios.get("http://localhost:5000/bill");
//       const res = await axios.get("http://localhost/murugan/bills/get_all.php");
//       const usageBills = res.data.filter((bill) => bill.type !== "deduction");
//       setBills(usageBills);
//       computeProductStats(usageBills);
//     } catch (err) {
//       console.error("Failed to fetch all bills", err);
//     }
//   };

//   const computeProductStats = (billsData) => {
//     const productCount = {};
//     billsData.forEach((bill) => {
//       bill.items.forEach((item) => {
//         productCount[item.product] =
//           (productCount[item.product] || 0) + item.quantity;
//       });
//     });
//     setProductStats(productCount);
//   };

//   return (
//     <div className="p-2">
//       <h2 className="text-2xl font-semibold mb-4 text-green-800">
//         Worker Billing Details (Admin)
//       </h2>

//       {/* Worker Selection */}
//       <div className="mb-6">
//         <h3 className="text-lg font-medium mb-2">Select Worker:</h3>
//         <div className="flex flex-wrap gap-3">
//           {/* All Workers Button */}
//           <button
//             onClick={fetchAllBills}
//             className={`px-4 py-2 rounded font-medium ${
//               isShowingAll
//                 ? "bg-blue-300 text-blue-900"
//                 : "bg-blue-100 text-blue-800 hover:bg-blue-200"
//             }`}
//           >
//             Show All Bills
//           </button>

//           {/* Individual Worker Buttons */}
//           {workers.map((worker) => (
//             <button
//               key={worker.id}
//               onClick={() => fetchBills(worker.id)}
//               className={`px-4 py-2 rounded font-medium ${
//                 selectedWorker === worker.id
//                   ? "bg-blue-300 text-blue-900"
//                   : "bg-blue-100 text-blue-800 hover:bg-blue-200"
//               }`}
//             >
//               {/* {worker.id} */}
//               {worker.username}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="mb-8">
//         <h3 className="text-xl font-semibold mb-3 text-red-600">
//           Pending Requests
//         </h3>
//         {requests
//           .filter((r) => r.status === "pending")
//           .map((req) => (
//             <div key={req._id} className="bg-white p-4 mb-4 rounded shadow">
//               <p className="text-gray-700 font-medium mb-2">
//                 Worker ID: {req.workerId}
//               </p>
//               <ul className="list-disc pl-5">
//                 {req.items.map((item, idx) => (
//                   <li key={idx}>
//                     {item.product} - {item.requested}
//                   </li>
//                 ))}
//               </ul>
//               <div className="mt-3 space-x-3">
//                 <button
//                   className="btn btn-sm btn-success"
//                   // onClick={() => handleApprove(req._id, req)}
//                   onClick={() =>
//                     handleApprove(req.id, {
//                       workerId: req.worker_id,
//                       items: req.items,
//                     })
//                   }
//                 >
//                   Approve
//                 </button>
//                 <button
//                   className="btn btn-sm btn-danger"
//                   onClick={() => handleReject(req.id)}
//                 >
//                   Reject
//                 </button>
//               </div>
//             </div>
//           ))}
//       </div>

//       {/* Product Stats */}
//       {(selectedWorker || isShowingAll) &&
//         Object.keys(productStats).length > 0 && (
//           <div className="mb-6">
//             <h4 className="text-lg font-semibold mb-2">
//               📦 Product Usage Summary
//             </h4>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//               {Object.entries(productStats).map(([product, count]) => (
//                 <div key={product} className="bg-yellow-100 p-4 rounded shadow">
//                   <h5 className="text-lg font-semibold text-yellow-800">
//                     {product}
//                   </h5>
//                   <p className="text-sm">Total Quantity: {count}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//       {/* Bills Section */}
//       {(selectedWorker || isShowingAll) && (
//         <div>
//           <h4 className="text-xl font-semibold text-gray-700 mb-4">
//             {isShowingAll ? "All Worker Bills" : `Bills for ${selectedWorker}`}
//           </h4>

//           {bills.length === 0 ? (
//             <p className="text-gray-500">No bills found.</p>
//           ) : (
//             bills.map((bill) => (
//               <div
//                 key={bill._id || bill.id}
//                 className="card mb-4 shadow-sm bg-white p-4 rounded"
//               >
//                 <h5 className="mb-3 text-green-700 font-semibold">
//                   🧾 Bill Date: {bill.date}
//                 </h5>
//                 <div className="overflow-x-auto">
//                   <table className="table-auto w-full text-sm border">
//                     <thead className="bg-green-100">
//                       <tr>
//                         <th className="p-2 border">Product</th>
//                         <th className="p-2 border">Quantity</th>
//                         <th className="p-2 border">Price (₹)</th>
//                         <th className="p-2 border">Total (₹)</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {bill.items.map((item, index) => (
//                         <tr key={index}>
//                           <td className="p-2 border">{item.product}</td>
//                           <td className="p-2 border">{item.quantity}</td>
//                           <td className="p-2 border">{item.price}</td>
//                           <td className="p-2 border">
//                             {item.price * item.quantity}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="text-end font-semibold mt-2">
//                   Grand Total: ₹{bill.total}
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default WorkerDetails;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Api } from "../Api/Api";

const WorkerDetails = () => {
  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [bills, setBills] = useState([]);
  const [productStats, setProductStats] = useState({});
  const [isShowingAll, setIsShowingAll] = useState(false);
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    const res = await axios.get(`${Api}cart-request/get_all.php`);
    setRequests(res.data);
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleApprove = async (id, cleanReqData) => {
    // optimistic remove so UI is snappy
    const backup = requests.slice();
    setRequests((prev) => prev.filter((r) => r.id !== id));

    try {
      const res = await axios.post(
        `${Api}cart-request/approve.php?id=${id}`,
        cleanReqData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // success: refresh bills and optionally re-fetch requests to ensure consistency
      await fetchAllBills();
      await fetchRequests(); // ensure server state and UI match
      console.log("Approve response:", res.data);
    } catch (err) {
      console.error("Approval failed", err.response?.data || err.message);
      // rollback optimistic update
      setRequests(backup);
      // show user-friendly message
      alert(
        "Approval failed: " +
          (err.response?.data?.error ||
            err.message ||
            "See console for details")
      );
    }
  };

  const handleReject = async (id) => {
    try {
      await axios.post(`${Api}cart-request/reject.php?id=${id}`);

      // ✅ Remove from state immediately
      setRequests((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      console.error("Rejection failed", err);
    }
  };

  useEffect(() => {
    fetchAllBills();
    setIsShowingAll(true);
  }, []);

  useEffect(() => {
    const fetchWorkers = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${Api}worker/get_all.php`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setWorkers(res.data); // res.data should be an array of worker objects
      } catch (err) {
        console.error("Failed to fetch workers:", err);
      }
    };

    fetchWorkers();
  }, []);

  const fetchBills = async (workerId, workerName) => {
    try {
      const res = await axios.get(
        `${Api}bills/get_by_worker.php?worker_id=${workerId}`
      );

      const usageBills = res.data.filter(
        (bill) =>
          bill.type !== "deduction" &&
          bill.worker_id === workerId &&
          bill.worker_name === workerName
      );

      setBills(usageBills);
      setSelectedWorker(workerId);
      setIsShowingAll(false);
      computeProductStats(usageBills);
    } catch (err) {
      console.error("Failed to fetch bills", err);
    }
  };

  const fetchAllBills = async () => {
    try {
      const res = await axios.get(`${Api}bills/get_all.php`);
      console.log("fetch1", res.data);
      const usageBills = res.data.filter((bill) => bill.type !== "deduction");
      console.log("fetch2:", usageBills);
      setBills(usageBills);
      computeProductStats(usageBills);
    } catch (err) {
      console.error("Failed to fetch all bills", err);
    }
  };

  const computeProductStats = (billsData) => {
    const productCount = {};
    billsData.forEach((bill) => {
      bill.items.forEach((item) => {
        productCount[item.product] =
          (productCount[item.product] || 0) + item.quantity;
      });
    });
    setProductStats(productCount);
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4 text-green-800">
        Worker Billing Details (Admin)
      </h2>
      {/* Worker Selection */}
      <div className="mb-6">
        <h3 className="text-lg font-medium mb-2">Select Worker:</h3>
        <div className="flex flex-wrap gap-3">
          {/* All Workers Button */}
          <button
            onClick={fetchAllBills}
            className={`px-4 py-2 rounded font-medium ${
              isShowingAll
                ? "bg-blue-300 text-blue-900"
                : "bg-blue-100 text-blue-800 hover:bg-blue-200"
            }`}
          >
            Show All Bills
          </button>

          {workers.map((worker) => (
            <button
              key={worker.id}
              onClick={() => fetchBills(worker.id, worker.username)}
              className={`px-4 py-2 rounded font-medium ${
                selectedWorker === worker.id
                  ? "bg-blue-300 text-blue-900"
                  : "bg-blue-100 text-blue-800 hover:bg-blue-200"
              }`}
            >
              {worker.username}
            </button>
          ))}
        </div>
      </div>

      <div className="mb-8">
        <h3 className="text-xl font-semibold mb-3 text-red-600">
          Pending Requests
        </h3>
        {requests
          .filter((r) => r.status === "pending")
          .map((req) => (
            <div key={req.id} className="bg-white p-4 mb-4 rounded shadow">
              <p className="text-gray-700 font-medium mb-2">
                Worker ID: {req.worker_id}
              </p>
              <ul className="list-disc pl-5">
                {req.items.map((item, idx) => (
                  <li key={idx}>
                    {item.product} - {item.requested}
                  </li>
                ))}
              </ul>
              <div className="mt-3 space-x-3">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() =>
                    handleApprove(req.id, {
                      workerId: req.worker_id,
                      items: req.items,
                    })
                  }
                >
                  Approve
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleReject(req.id)}
                >
                  Reject
                </button>
              </div>
            </div>
          ))}
      </div>

      {/* Product Stats */}
      {(selectedWorker || isShowingAll) &&
        Object.keys(productStats).length > 0 && (
          <div className="mb-6">
            <h4 className="text-lg font-semibold mb-2">
              📦 Product Usage Summary
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {Object.entries(productStats).map(([product, count]) => (
                <div key={product} className="bg-yellow-100 p-4 rounded shadow">
                  <h5 className="text-lg font-semibold text-yellow-800">
                    {product}
                  </h5>
                  <p className="text-sm">Total Quantity: {count}</p>
                </div>
              ))}
            </div>
          </div>
        )}

      {/* Bills Section */}
      {(selectedWorker || isShowingAll) && (
        <div>
          <h4 className="text-xl font-semibold text-gray-700 mb-4">
            {isShowingAll ? "All Worker Bills" : `Bills for ${selectedWorker}`}
          </h4>

          {bills.length === 0 ? (
            <p className="text-gray-500">No bills found.</p>
          ) : (
            bills.map((bill) => (
              <div
                key={bill.id || bill.id}
                className="card mb-4 shadow-sm bg-white p-4 rounded"
              >
                <h5 className="mb-3 text-green-700 font-semibold">
                  🧾 Bill Date: {bill.date}
                </h5>
                <div className="overflow-x-auto">
                  <table className="table-auto w-full text-sm border">
                    <thead className="bg-green-100">
                      <tr>
                        <th className="p-2 border">Product</th>
                        <th className="p-2 border">Quantity</th>
                        <th className="p-2 border">Price (₹)</th>
                        <th className="p-2 border">Total (₹)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bill.items.map((item, index) => (
                        <tr key={index}>
                          <td className="p-2 border">{item.product}</td>
                          <td className="p-2 border">{item.quantity}</td>
                          <td className="p-2 border">{item.price}</td>
                          <td className="p-2 border">
                            {item.price * item.quantity}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="text-end font-semibold mt-2">
                  Grand Total: ₹{bill.total}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default WorkerDetails;
